const mealFieldMap = {
  '猿辅导A-毕业生': ['educationalBackground', 'degree'],
  '猿辅导B-在校生': ['academicReport'],
  斑马背调: [],
}

export { mealFieldMap }
